@if (headerBlock(); as headerBlock) {
    <packbo-header-block [headerBlock]="headerBlock" />
}

<div class="hidden justify-between pr-0 lg:flex" [class.pr-8]="!shouldShowSuppliers()">
    @if (subcategories().length) {
        <aside class="max-w-80 min-w-80">
            <section class="mb-8 flex flex-col pr-6 pl-8">
                <packbo-subcategory-sidebar
                    [subcategories]="subcategories()"
                    [(selectedSubcategoryId)]="selectedSubcategoryId"
                />
            </section>
        </aside>
    }

    @if (shouldShowSuppliers()) {
        <section class="border-neutral-variant-40/20 mb-8 flex grow flex-col border-l pr-6 pl-8">
            <div class="mb-8">
                <packbo-search
                    [(searchValue)]="searchValue"
                    [(postalCode)]="postalCode"
                    [(distance)]="distance"
                    [(isEcoFriendly)]="isEcoFriendly"
                    [(selectedCertificationsIds)]="selectedCertificationsIds"
                    [inputResultsLength]="suppliers().length"
                    [inputItemsCertifications]="itemsCertifications()"
                    [inputSearchType]="'supplier'"
                    (outputSearch)="getSuppliers($event)"
                />
            </div>

            <packbo-supplier-card-shimmer [class.hidden]="!shouldShowShimmer()" />

            <div [class.hidden]="shouldShowShimmer()">
                @if (suppliers().length) {
                    <packbo-supplier-card
                        [postalCode]="userPostalCode()"
                        [suppliers]="suppliers()"
                        (allImagesLoaded)="onSupplierImagesLoaded()"
                    />
                } @else {
                    <ng-container *ngTemplateOutlet="emptyState; context: { type: 'suppliers' }" />
                }
            </div>

            @if (shouldShowPagination()) {
                <div class="mt-auto">
                    <packbo-paginator [(currentPage)]="currentPage" [totalPages]="pagination().totalPages" />
                </div>
            }
        </section>
    } @else {
        @if (subcategories().length) {
            <section class="border-neutral-variant-40/20 mb-8 grow border-l">
                <div class="mb-8 pl-6">
                    <packbo-search
                        [(searchValue)]="searchValue"
                        [(postalCode)]="postalCode"
                        [(distance)]="distance"
                        [inputResultsLength]="filteredSubcategories().length"
                        [inputSearchType]="'subcategory'"
                        (outputSearch)="filterSubcategoriesByName($event.search)"
                    />
                </div>

                <div class="flex justify-between">
                    <div
                        [class.hidden]="!filteredSubcategories().length"
                        class="grid h-fit grid-cols-1 justify-center gap-8 px-6 xl:mb-8 xl:grid-cols-2 2xl:grid-cols-3"
                    >
                        @for (subcategory of filteredSubcategories(); track subcategory.id) {
                            <packbo-subcategory-card
                                [subcategory]="subcategory"
                                [(selectedSubcategoryId)]="selectedSubcategoryId"
                            />
                        }
                    </div>

                    <div class="mx-auto hidden" [class.hidden]="filteredSubcategories().length">
                        <ng-container *ngTemplateOutlet="emptyState; context: { type: 'subcategories' }" />
                    </div>

                    <aside class="max-w-76 min-w-76">
                        @if (adBlocks(); as adBlocks) {
                            <packbo-ad-block [adBlock]="adBlocks[0]" />
                            <packbo-ad-block [adBlock]="adBlocks[1]" />
                        }
                    </aside>
                </div>
            </section>
        }
    }
</div>

<div class="mb-8 hidden h-full w-full flex-col items-center justify-center gap-3 lg:flex">
    @if (!subcategories().length && !shouldShowSuppliers()) {
        <ng-container *ngTemplateOutlet="emptyState; context: { type: 'subcategories' }" />
    }
</div>

<section class="mb-8 flex flex-col items-center justify-center gap-3 lg:hidden">
    @if (shouldShowSuppliers()) {
        <packbo-search
            class="max-w-91.5 min-w-91.5"
            [(searchValue)]="searchValue"
            [(postalCode)]="postalCode"
            [(isEcoFriendly)]="isEcoFriendly"
            [(selectedCertificationsIds)]="selectedCertificationsIds"
            [(selectedSubcategoryId)]="selectedSubcategoryId"
            [inputResultsLength]="suppliers().length"
            [inputItemsCertifications]="itemsCertifications()"
            [inputSearchType]="'supplier'"
            [subcategories]="subcategories()"
            (outputSearch)="getSuppliers($event)"
        />
        <packbo-supplier-card-shimmer [class.hidden]="!shouldShowShimmer()" />

        <div [class.hidden]="shouldShowShimmer()">
            @if (suppliers().length) {
                <packbo-supplier-card
                    [suppliers]="suppliers()"
                    [postalCode]="userPostalCode()"
                    (allImagesLoaded)="onSupplierImagesLoaded()"
                />
            } @else {
                <ng-container *ngTemplateOutlet="emptyState; context: { type: 'suppliers' }" />
            }
        </div>

        @if (shouldShowPagination()) {
            <div class="place-content-end">
                <packbo-paginator [(currentPage)]="currentPage" [totalPages]="pagination().totalPages" />
            </div>
        }
    } @else {
        <packbo-search
            class="max-w-91.5 min-w-91.5"
            [(selectedSubcategoryId)]="selectedSubcategoryId"
            [(searchValue)]="searchValue"
            [(postalCode)]="postalCode"
            [inputResultsLength]="filteredSubcategories().length"
            [inputSearchType]="'subcategory'"
            [subcategories]="subcategories()"
            (outputSearch)="filterSubcategoriesByName($event.search)"
        />
        @if (filteredSubcategories().length) {
            @for (content of mobileLayout(); track $index) {
                @switch (content.type) {
                    @case ("subcategories") {
                        @for (subcategory of content.subcategories; track subcategory.id) {
                            <packbo-subcategory-card
                                [subcategory]="subcategory"
                                [(selectedSubcategoryId)]="selectedSubcategoryId"
                            />
                        }
                    }
                    @case ("ad") {
                        @if (content.adBlock) {
                            <packbo-ad-block [adBlock]="content.adBlock" />
                        }
                    }
                }
            }
        } @else {
            <div class="mx-auto">
                <ng-container *ngTemplateOutlet="emptyState; context: { type: 'subcategories' }" />
            </div>
        }
    }
</section>

@if (adBlocks(); as adBlocks) {
    <packbo-ad-block [adBlock]="adBlocks[2]" />
}

<ng-template #emptyState let-type="type">
    <span class="mb-8 flex h-full flex-col items-center justify-center gap-3">
        <svg-icon
            class="text-primary"
            [svgStyle]="{ width: '400px', height: '400px' }"
            src="assets/icons/Folder-Not-Found.svg"
        />
        <span class="text-title-medium text-center">{{
            "category.no_" + (type === "subcategories" ? "subcategories" : "suppliers") | transloco
        }}</span>
        <span class="text-body-small text-center">{{
            "category.no_" + (type === "subcategories" ? "subcategories_description" : "suppliers_description")
                | transloco
        }}</span>
    </span>
</ng-template>
